import { Notification } from '@yandex-int/k-common/typings';

import * as constants from './constants';
import { UpdateNotificationRequestData } from './typings';

export const getNotificationsRequest = (payload?: { pageSize?: number }) =>
    ({
        type: constants.GET_NOTIFICATIONS_REQUEST,
        payload,
    }) as const;

export const getNotificationsSuccess = (notifications: Array<Notification>) =>
    ({
        type: constants.GET_NOTIFICATIONS_SUCCESS,
        notifications,
    }) as const;

export const getNotificationsError = () =>
    ({
        type: constants.GET_NOTIFICATIONS_ERROR,
    }) as const;

export const getNotificationsHeaderRequest = (payload?: { pageSize?: number }) =>
    ({
        type: constants.GET_NOTIFICATIONS_HEADER_REQUEST,
        payload,
    }) as const;

export const getNotificationsHeaderSuccess = (notifications: Array<Notification>) =>
    ({
        type: constants.GET_NOTIFICATIONS_HEADER_SUCCESS,
        notifications,
    }) as const;

export const getNotificationsHeaderError = () =>
    ({
        type: constants.GET_NOTIFICATIONS_HEADER_ERROR,
    }) as const;

export const updateNotificationsRequest = (request: UpdateNotificationRequestData) =>
    ({
        type: constants.UPDATE_NOTIFICATIONS_REQUEST,
        includeTypes: request.includeTypes,
        ids: request.ids,
        isViewed: request.isViewed,
    }) as const;

export const updateNotificationsSuccess = () =>
    ({
        type: constants.UPDATE_NOTIFICATIONS_SUCCESS,
    }) as const;

export const updateNotificationsError = () =>
    ({
        type: constants.UPDATE_NOTIFICATIONS_ERROR,
    }) as const;
